import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom'

import { reverse } from 'routes'
import { getMakerName, getBrandName } from 'utils/vehicle'

import './styles.scss'

export default function Vehicle(props) {

  const vehicle = props.vehicle

  const vehiclePlates = !!vehicle.plates ? `(${vehicle.plates})` : null
  const vehiclePolicyNumber = vehicle.policy_number || 'Sin póliza'
  const vehiclePolicyCompany = vehicle.policy_company || 'Sin aseguradora'

  let vehicleLink = reverse('clients:detail:data', {id: props.match.params.id, vehicleId: vehicle.id})

  if(!!vehicle.has_active_claim) {
    vehicleLink = reverse('clients:detail:claim', {id: props.match.params.id, vehicleId: vehicle.id})
  }

  return (
    <div id="VehicleItem" className="d-flex justify-content-between">
      <div className="Vehicle__data">
        <div className="VehicleItem__name">
          <p>{`${getMakerName(vehicle)} - ${getBrandName(vehicle)} `}<span>{vehiclePlates}</span> {!!vehicle.alias && <span>&nbsp;&nbsp;&nbsp;<b>Alias:</b> {vehicle.alias}</span>}</p>
        </div>
        <div className="VehicleItem__meta">
          <p># Poliza: <span>{vehiclePolicyNumber}</span></p>
          <p>Aseguradora: <span>{vehiclePolicyCompany}</span></p>
          {!!vehicle.has_active_claim && <p><span className={`is-active-${vehicle.has_active_claim}`}>Siniestro en progreso</span></p>}
        </div>
      </div>
      <div className="Vehicle__control">
        <Link className="btn btn-primary small detail-link d-flex align-items-center justify-content-around"
              to={vehicleLink}
              type="primary" size="small">
              <i className="material-icons">remove_red_eye</i>
              <span>Ver más</span>
        </Link>
      </div>
    </div>
  )
}

Vehicle.propTypes = {
  vehicle: PropTypes.shape({
    is_active: PropTypes.bool.isRequired,
    plates: PropTypes.string,
    policy_number: PropTypes.string,
    policy_company: PropTypes.string,
    maker: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
  })
}



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/Vehicles/Vehicle/index.js